import React from "react"
interface EventCalendarProps {
    fill: string;
    height?: string;
    width?: string;
}
const EventCalendar: React.FC<EventCalendarProps> = ({ fill, height, width }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_627_777" 
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                <rect width="18" height="18" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_627_777)">
                <path d="M8.21273 13.4884L5.80986 11.0855L6.62331 10.2721L8.21273 11.8615L11.3771 8.6971L12.1906 9.51055L8.21273 13.4884ZM3.98102 16.1249C3.60217 16.1249 3.28149 15.9937 3.01899 15.7312C2.75649 15.4687 2.62524 15.148 2.62524 14.7692V4.73076C2.62524 4.35191 2.75649 4.03123 3.01899 3.76873C3.28149 3.50623 3.60217 3.37498 3.98102 3.37498H5.01949V1.78845H6.17331V3.37498H11.856V1.78845H12.981V3.37498H14.0194C14.3983 3.37498 14.719 3.50623 14.9815 3.76873C15.244 4.03123 15.3752 4.35191 15.3752 4.73076V14.7692C15.3752 15.148 15.244 15.4687 14.9815 15.7312C14.719 15.9937 14.3983 16.1249 14.0194 16.1249H3.98102ZM3.98102 15H14.0194C14.0771 15 14.13 14.9759 14.1781 14.9279C14.2262 14.8798 14.2502 14.8269 14.2502 14.7692V7.73076H3.75023V14.7692C3.75023 14.8269 3.77426 14.8798 3.82234 14.9279C3.87043 14.9759 3.92332 15 3.98102 15Z" fill={fill} />
            </g>
        </svg>
    );
};

export default EventCalendar
